import { h, CircleNode, CircleNodeModel } from '@logicflow/core';

// 自定义圆形节点（属性）
export class CustomCircleNode extends CircleNode {
  // 重写getText方法来支持多行文本显示
  getText() {
    const { model } = this.props;
    const { text } = model;

    if (!text || !text.value) {
      return null;
    }

    // 处理多行文本
    const textLines = text.value.split('\n');
    const lineHeight = 16; // 行高
    const totalHeight = (textLines.length - 1) * lineHeight;
    
    // 如果只有一行文本，使用父类的默认渲染
    if (textLines.length === 1) {
      return super.getText();
    }

    // 多行文本渲染
    return h(
      'g',
      {
        className: 'lf-node-text-group',
      },
      textLines.map((line, index) => 
        h(
          'text',
          {
            x: text.x,
            y: text.y - totalHeight / 2 + index * lineHeight,
            fill: '#000000',
            textAnchor: 'middle',
            dominantBaseline: 'middle',
            style: {
              fontSize: 14,
              userSelect: 'none',
            },
            key: `line-${index}`,
          },
          line
        )
      )
    );
  }
}

export class CustomCircleNodeModel extends CircleNodeModel {
  initNodeData(data: any) {
    super.initNodeData(data);
    this.text.draggable = false; // 不允许文本被拖动
    this.text.editable = false; // 不允许文本被编辑
  }
  getTextStyle() {
    const style = super.getTextStyle();
    style.fontSize = 14;
    // style.color = 'red';
    return style;
    // return {
    //   ...style,
    //   color: '#000000',
    //   // fontSize: 24,
    //   fontWeight: 'bold',
    //   overflowMode: 'default',
    //   lineHeight: 1.2,
    // };
  }
}
